module.exports = __webpack_public_path__ + "img/img-logo-pig.c00bb1fd.svg";